<template>
  <div class="createPlayStep">
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div class="secondstep">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="120px"
        >
          <el-form-item label="活动名称:" prop="activityName">
            <el-input
              v-model="ruleForm.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 340px"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间:" prop="activityTimeValue">
            <div class="my_select_time">
              <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                style="width: 340px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
                :clearable="false"
                @change="activityTimeChange"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="activityTimeValue = []"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天
              <span style="color: #2670fb">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动有效期不可超过订购有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象:" required>
            <el-radio-group
              v-model="ruleForm.activityObject"
              :disabled="isStartEdit"
              @change="handleActivityObj"
              style="margin-right: 16px"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定身份</el-radio>
              <el-radio :label="2" disabled>指定人群</el-radio>
            </el-radio-group>
            <el-popover
              placement="right-start"
              trigger="hover"
              content="您不满足使用该功能的条件，请联系专属客服了解~"
            >
              <el-button slot="reference" disabled>{{
                peopleList.length == 0
                  ? "选择人群"
                  : `已选${peopleList.length}个`
              }}</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item
            label="新老客户:"
            required
            v-if="ruleForm.activityObject == '1'"
          >
            <el-radio-group
              v-model="ruleForm.newOldCustomer"
              :disabled="isStartEdit"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">新客</el-radio>
              <el-radio :label="2">老客</el-radio>
            </el-radio-group>
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content">
                1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
              </div>
              <div
                class="cursorPointer"
                style="
                  display: inline-block;
                  margin-left: 16px;
                  font-size: 12px;
                  color: #999;
                "
              >
                <span>新老客说明</span>
                <i class="el-icon-question"></i>
              </div>
            </el-tooltip>
          </el-form-item>
          <!-- :disabled="
                nowType == 'look' ||
                (nowType == 'edit' && activityData.status == 2)
              " -->
          <el-form-item
            label="参与对象:"
            prop="partner"
            v-if="ruleForm.activityObject == '1'"
          >
            <el-checkbox-group
              v-model="ruleForm.allowLevel"
              @change="checkListchange1"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="ruleForm.allowLevel == -1"
                >非会员</el-checkbox
              >

              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.allowLevel == -1"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <!-- <el-form-item label="领取时间:" required>
            <div>
              <span> 用户生日前 </span>
              <el-input
                v-model="ruleForm.birthBeforeDay"
                @input="ruleForm.birthBeforeDay = getNumberData($event, 0, 0)"
                style="width: 70px"
                placeholder="请输入"
                :disabled="isStartEdit"
              ></el-input>
              <span> 天到后 </span>
              <el-input
                v-model="ruleForm.birthAfterDay"
                @input="ruleForm.birthAfterDay = getNumberData($event, 0, 0)"
                style="width: 70px"
                placeholder="请输入"
                :disabled="isStartEdit"
              ></el-input>
              <span> 天可领取奖品</span>
            </div>
          </el-form-item> -->
          <el-form-item label="活动条件:">
            <el-checkbox
              v-model="ruleForm.condFollow"
              :disabled="backgroundOpacity"
              >关注店铺后方可参与活动</el-checkbox
            ></el-form-item
          >
          <el-form-item label="可领奖等级:" required>
            <template>
              <div class="prize_box">
                <span>
                  <span class="display_inliene">
                    <el-checkbox-group
                      v-model="ruleForm.partner"
                      @change="checkListchange"
                      :disabled="isStartEdit"
                    >
                      <el-checkbox label="-1" name="partner"
                        >全部会员等级</el-checkbox
                      >
                      <el-checkbox
                        v-for="item in levelList"
                        :key="item.value"
                        :label="item.value"
                        name="partner"
                        >{{ item.label }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </span>
                </span>
              </div>
            </template>
          </el-form-item>
          <!-- v3.39 -->
          <el-form-item label="等级规则设置:" required>
            <div class="setting-level">
              <div
                :class="[
                  'setting-level-item',
                  { 'setting-level-item__active': levelIndex == index },
                ]"
                v-for="(item, index) in getChooseLevel"
                :key="item.value"
                @click="levelClick(index)"
              >
                <span>{{ item.label }}</span>
              </div>
            </div>
            <template v-for="(item, it) in prizeSettingListLevel">
              <div class="rule-set-box" v-if="levelIndex == it" :key="it">
                <el-form-item label="等级条件:" required label-width="125px">
                  <!-- :disabled="nowType == 'look'" -->
                  <el-input
                    v-model="item.memberLevelCondition"
                    maxlength="20"
                    show-word-limit
                    style="width: 330px"
                    placeholder="请输入"
                  ></el-input>
                  <div style="margin-top: 12px">
                    <div style='color: rgb(245, 154, 34);'>输入达到该等级的等级条件，如：消费200元可达该等级</div>
                    <div style='color: rgb(245, 154, 34);'>
                      仅用于C端提示使用，无实际校验效果，建议与实际会员升级体系保持一致。
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="等级奖品:" required label-width="125px">
                  <div>
                    -开启【高等级可领】，是指配置了2级会员奖品，除了达到2级的会员可领取外，3级及以上的会员也可领取；
                  </div>
                  <div>
                    -开启【升级可领取】，是指用户在活动时间内先后进入活动发生升级到当前等级才可领取对应奖品；
                  </div>
                  <div class="mr-bt-12">
                    -开启【降级不可领】，是指用户在活动时间内先后进入活动退级到当前等级不可领对应奖品；
                  </div>
                  <div>
                    <el-table
                      v-if="levelIndex == it"
                      :data="item.settingList"
                      style="border: 1px solid #f0f0f0"
                      :header-cell-style="{
                        background: '#fafafa',
                        'text-align': 'center',
                      }"
                      :cell-style="{
                        'text-align': 'center',
                      }"
                    >
                      <el-table-column prop="date" label="序号" min-width="120">
                        <template slot-scope="scope">
                          <span>{{ scope.$index + 1 }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="奖品类型" min-width="120">
                        <template slot-scope="scope">
                          <div v-if="backgroundOpacity || isStartEdit">
                            <span
                              style="color: #909399"
                              v-if="scope.row.prizeType == 3"
                              >{{ scope.row.title }}</span
                            >
                            <span
                              style="color: #909399"
                              v-else-if="scope.row.prizeType"
                              >{{ scope.row.prizeType | prizeType }}</span
                            >
                            <span v-else style="color: #909399">选择奖品</span>
                          </div>
                          <div v-else>
                            <div>
                              <!-- :disabled="nowType == 'look'" -->
                              <el-button
                                style="width: auto"
                                key="2"
                                type="text"
                                :disabled="backgroundOpacity"
                                v-if="scope.row.prizeType"
                                @click="centerVis2(scope)"
                                >{{
                                  scope.row.prizeType | prizeType
                                }}</el-button
                              >
                              <!-- :disabled="nowType == 'look'" -->
                              <el-button
                                v-else
                                key="3"
                                @click="centerVis2(scope)"
                                :disabled="backgroundOpacity"
                                type="text"
                                style="width: auto"
                                >选择奖品</el-button
                              >
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="name"
                        label="奖品名称"
                        min-width="120"
                      >
                        <template slot-scope="scope">
                          <div>
                            <span
                              v-if="
                                scope.row.prizeType == 3 ||
                                scope.row.prizeType == 10
                              "
                              style="width: auto; white-space: normal"
                            >
                              {{ scope.row.title }}
                            </span>
                            <span v-else-if="scope.row.prizeType">{{
                              scope.row.prizeType | prizeType
                            }}</span>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column label="值" prop="price" min-width="120">
                      </el-table-column>
                      <el-table-column label="奖品总份数" min-width="120">
                        <!-- :disabled="nowType == 'look'"        @input="
                              scope.row.totalAmount = hd_getNumberData(
                                $event,
                                0
                              )
                            "-->
                        <template slot-scope="scope">
                          <el-input
                            v-model="scope.row.totalAmount"
                            :disabled="backgroundOpacity"
                            placeholder="请输入"
                          ></el-input>
                        </template>
                      </el-table-column>

                      <el-table-column label="图片(208px*208px)" min-width="140">
                        <template slot-scope="scope">
                          <el-image
                            class="elImg"
                            :src="scope.row.logo"
                            fit="contain"
                            style="
                              width: 40px;
                              height: 40px;
                              background: #d9d9d9;
                              border-radius: 4px 4px 4px 4px;
                            "
                          >
                            <div slot="error" class="image-slot"></div>
                          </el-image>
                        </template>
                      </el-table-column>

                      <el-table-column label="领取设置" min-width="150">
                        <template slot-scope="scope">
                          <div class="mr-bt-12">
                            <span class="mr-r-6">高等级可领</span>
                            <el-switch
                              :disabled="backgroundOpacity"
                              v-model="scope.row.highLevelGetFlag"
                            ></el-switch>
                          </div>
                          <div class="mr-bt-12">
                            <span class="mr-r-6">升级可领取</span>
                            <el-switch
                              :disabled="backgroundOpacity"
                              v-model="scope.row.upgradeGetFlag"
                            ></el-switch>
                          </div>
                          <div>
                            <span class="mr-r-6">降级不可领</span>
                            <el-switch
                              :disabled="backgroundOpacity"
                              v-model="scope.row.downgradeGetFlag"
                            ></el-switch>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column label="操作" min-width="250">
                        <template slot-scope="scope">
                          <div
                            v-if="backgroundOpacity || activityData.isStart"
                            class="btn-wrap"
                          >
                            <div style="color: #909399; margin-right: 10px">
                              上传图片
                            </div>
                            <div
                              style="color: #909399"
                              v-if="scope.row.prizeType != 3"
                            >
                              重置
                            </div>
                          </div>
                          <div class="btn-wrap" v-else style="display: flex">
                            <el-upload
                              :disabled="activityData.isStart"
                              class="upload"
                              action="/api/image/upload"
                              :show-file-list="false"
                              :before-upload="beforeUpload3"
                              :on-success="
                                (file) => {
                                  return handleUpload3(file, scope);
                                }
                              "
                            >
                              <el-button
                                type="text"
                                class="text-btn"
                                style="margin-right: 10px"
                                :disabled="backgroundOpacity || isStartEdit"
                              >
                                上传图片
                              </el-button>
                            </el-upload>
                            <!-- :disabled="nowType == 'look'" -->
                            <el-button
                              v-if="item.settingList.length > 1"
                              type="text"
                              style="“width: auto”"
                              class="styleBtns"
                              @click="itemDel(scope.$index, item)"
                              :disabled="backgroundOpacity || isStartEdit"
                              >删除</el-button
                            >
                            <!-- :disabled="nowType == 'look'" -->
                            <el-button
                              v-if="scope.$index > 0"
                              type="text"
                              class="styleBtns"
                              @click="upLvGoods(scope.$index, item)"
                              :disabled="backgroundOpacity || isStartEdit"
                              >上移</el-button
                            >
                            <!-- :disabled="nowType == 'look'" -->
                            <el-button
                              v-if="scope.$index < item.settingList.length - 1"
                              type="text"
                              class="styleBtns"
                              @click="downLvGoods(scope.$index, item)"
                              :disabled="backgroundOpacity || isStartEdit"
                              >下移</el-button
                            >
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- :disabled="nowType == 'look'" -->
                    <el-button
                      type="blue"
                      v-if="
                        levelIndex == it &&
                        item.settingList.length < 5 &&
                        !isStartEdit
                      "
                      @click="addSetting(item)"
                      style="margin-top: 12px"
                      >增加奖品{{ item.settingList.length }}/5</el-button
                    >
                  </div>
                </el-form-item>
                <el-form-item label="点击去升级:" label-width="125px">
                  <el-input
                    v-model="item.jumpInfo"
                    placeholder=""
                    style="width: 320px"
                    :disabled="backgroundOpacity"
                  >
                  </el-input>
                  <span
                    style="color: #999999; margin-left: 20px; font-size: 13px"
                    >当用户查看高等级奖品时，将引导用户升级，可配置升级跳转路径</span
                  >
                </el-form-item>

                <el-form-item label="等级权益:" label-width="125px">
                  <el-table
                    :data="item.gradeEquityList"
                    style="border: 1px solid #eeeeee; width: 100%"
                    :header-cell-style="{
                      background: '#F0F2F7',
                      'text-align': 'left',
                    }"
                  >
                    <el-table-column label="权益图标" width="150">
                      <template slot-scope="scope">
                        <img
                          :src="scope.row.benefitEnableIconUrl"
                          style="width: 50px; height: 50px"
                          disabled
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="权益名称"
                      min-width="150"
                      prop="name"
                    >
                    </el-table-column>
                    <el-table-column
                      label="跳转链接"
                      min-width="150"
                      prop="jumpType"
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.jumpInfo || "-" }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <!-- :disabled="nowType == 'look'" -->
                        <el-button
                          type="text"
                          class='styleBtns'
                          :disabled="backgroundOpacity"
                          @click="equityDel(scope.$index, item)"
                          >移除</el-button
                        >
                        <!-- :disabled="nowType == 'look'" -->
                        <el-button
                          v-if="scope.$index > 0"
                          type="text"
                           class='styleBtns'
                          :disabled="backgroundOpacity"
                          @click="upEquity(scope.$index, item)"
                          >上移</el-button
                        >
                        <!-- :disabled="nowType == 'look'" -->
                        <el-button
                          v-if="scope.$index < item.settingList.length - 1"
                          type="text"
                           class='styleBtns'
                          :disabled="backgroundOpacity"
                          @click="downEquity(scope.$index, item)"
                          >下移</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- :disabled="nowType == 'look'" -->
                  <el-button
                    v-if="item.gradeEquityList"
                    type="blue"
                    @click="addEquity(item)"
                    :disabled="backgroundOpacity"
                    style="margin-top: 12px; width: 120px"
                    >添加权益{{ item.gradeEquityList.length }}/20</el-button
                  >
                </el-form-item>
              </div>
            </template>
          </el-form-item>
          <el-form-item label="每人领奖限制:" label-width="125px">
            <span class="mr-r-6">当前活动每人限制领取</span>
            <!-- :disabled="nowType == 'look'" -->
            <el-input
              :disabled="backgroundOpacity || isStartEdit"
              v-model="ruleForm.limitPerPerson"
              class="mr-r-6"
              style="width: 100px"
            ></el-input>
            <span>次奖品，超出次数，即使再升级也不能领取奖品</span>
            <span style="color: #999999"
              >（不填则默认不限，只要符合条件即可领）</span
            >
          </el-form-item>
          <el-form-item label="活动主题：" label-position="left">
            <div class="common-flex">
              <!-- :disabled="nowType == 'look'" -->
              <el-input
                v-model="ruleForm.theme"
                maxlength="10"
                show-word-limit
                placeholder="请输入"
                :disabled="backgroundOpacity"
                style="width: 320px"
              ></el-input>
              <span class="lastTime" style="color: #666">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="不填则C端不显示"
                  placement="bottom"
                >
                  <i class="el-icon-question cursorPointer"></i>
                </el-tooltip>
              </span>
            </div>
          </el-form-item>
          <el-form-item label="活动说明：" label-position="left">
            <div class="common-flex">
              <!-- :disabled="nowType == 'look'" -->
              <el-input
                v-model="ruleForm.description"
                maxlength="25"
                show-word-limit
                placeholder="请输入"
                :disabled="backgroundOpacity"
                style="width: 320px"
              ></el-input>
              <span class="lastTime" style="color: #666">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="不填则C端不显示"
                  placement="bottom"
                >
                  <i class="el-icon-question cursorPointer"></i>
                </el-tooltip>
              </span>
            </div>
          </el-form-item>
          <el-form-item label="主题文字颜色：" label-position="left">
            <div class="buttonGroup">
              <!-- :disabled="nowType == 'look'" -->
              <el-color-picker
                v-model="ruleForm.wordColor"
                :disabled="backgroundOpacity"
                size="small"
              ></el-color-picker>
              <!-- :disabled="nowType == 'look'" -->
              <el-button
                type="text"
                @click="textColorReset"
                :disabled="backgroundOpacity"
                style="margin: 0 12px 0 -28px;position:absolute; "
                >重置</el-button
              >
            </div>
          </el-form-item>

          <el-form-item label="曝光商品:" prop="exposure" class="zindexBox">
            <el-checkbox
              v-model="ruleForm.exposureSwitch"
              :disabled="backgroundOpacity"
            >
              是否添加曝光商品
            </el-checkbox>
            <el-button
              style="width: 155px; margin: 0 15px"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false || backgroundOpacity"
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </el-button>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px 10px 0px 10px;
              "
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(item, index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <el-form-item label="活动规则:" prop="ruleDescription">
            <div style="width: 500px; padding: 8px 0; position: relative">
              <!-- 淘宝v3.36 -->
              <!-- <div style="margin-top: -7px">
                <el-checkbox
                  v-model="activePage"
                  :disabled="backgroundOpacity"
                  @change="handleCheckAllChangeTaoBao"
                  style="float: left; line-height: 22px"
                  >活动规则是否展示活动页<el-tooltip
                    class="item"
                    effect="light"
                    content="选中即展示在活动页中间，用户可直观查看活动规则"
                    placement="bottom"
                  >
                    <el-button
                      type="text"
                      style="width: 35px; margin-left: -8px"
                    >
                      <i style="margin-top: -20px" class="el-icon-question"></i>
                    </el-button> </el-tooltip
                ></el-checkbox>
                <span> </span>
              </div> -->
              <!-- end -->
              <el-input
                type="textarea"
                class="textarea"
                style="width: 484px"
                resize="none"
                v-model="ruleForm.activityRulesText"
                :disabled="backgroundOpacity"
                :maxlength="2000"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.activityRulesText.length
                    ? ruleForm.activityRulesText.length - 1
                    : 0
                }}/2000）
              </div>
              <div>
                <el-button
                  type="primary"
                  class="generate"
                  plain
                  @click="generateRule"
                  :disabled="backgroundOpacity"
                >
                  生成规则
                </el-button>

                <span class="desc">
                  <i
                    class="el-alert__icon el-icon-info"
                    style="color: #999"
                  ></i>
                  点击按钮自动生成规则，也可以自己编辑信息
                </span>
              </div>
            </div>
          </el-form-item>

          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
    </div>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="allowLevel"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      @close="colseDialog"
      :num="1"
      :echoDate="echoDate"
      :JingdouCount="JingdouCount"
      v-if="showDialog"
      ref="selectProduct"
      :reShop="true"
      @choose-shop="getTheData"
    >
    </selectProduct>

    <!-- 统一奖品弹窗 -->
    <select-Product
      @close="colseDialog1"
      :num="1"
      :echoDate="echoDate1"
      :JingdouCount="JingdouCount1"
      v-if="showDialog1"
      ref="selectProduct1"
      @choose-shop="getTheData1"
    ></select-Product>
    <!-- 权益弹窗 -->
    <equityChosePop
      v-if="isSelectEquity"
      :isShow="isSelectEquity"
      @input="(val) => (isSelectEquity = val)"
      @select="selectEquity"
      :selectedList="gradeEquityList"
    />
  </div>
</template>

<script>
import equityChosePop from "@/components/equity-chose-pop.vue";
import { getActivity, saveOrUpdate } from "@/api/integralCenter/birthdayGift";
import {
  createMemberUpgradeGift,
  purchaseActivityDetail,
} from "@/api/integralCenter/memberUpgrade";
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product";

import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";

export default {
  components: {
    selectProduct,
    selectPrize,
    selectGoodsMonitor,
    draggable,
    equityChosePop,
  },
  computed: {
    // 获取选中的会员
    getChooseLevel() {
      if (this.ruleForm.partner.includes("-1")) {
        return this.levelList;
      } else {
        return this.levelList.filter((item) =>
          this.ruleForm.partner.includes(item.value)
        );
      }
    },
    prizeSettingList() {
      let arr = [];
      this.prizeSettingListLevel.forEach((item) => {
        arr.push(...item.settingList);
      });
      return arr;
    },
    // 当前切换选中的权益列表
    gradeEquityList() {
      let arr = [];
      arr = this.prizeSettingListLevel[this.levelIndex]
        ? this.prizeSettingListLevel[this.levelIndex].gradeEquityList
        : [];
      return arr;
    },
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            }
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          // 如果是编辑状态且活动进行中(status=2)，禁用开始时间选择
          if (isStartEdit) {
            return true;
          }
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() >
                new Date(this.ruleForm.activityEndTime).getTime() ||
              time.getTime() < Date.now() - 8.64e7
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        selectableRange: (() => {
          let data = new Date();
          let hour = data.getHours();
          let minute = data.getMinutes();
          let second = data.getSeconds();
          return [`${hour}:${minute}:${second} - 23:59:59`];
        })(),
      },
      isSelectEquity: false, // 选择权益弹窗
      tableIndex2: 0,
      itemListForFilter: [],
      ladder: {
        prizeShowType: 0,
        orderCountType: 0,
      },
      JingdouCount: {
        prizeCount: 0,
      },
      JingdouCount1: {
        prizeCount: 0,
      },
      priceImg:
        "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_B/prizeShow.png", //默认产品图
      couponImg:
        "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_B/coupon.png",
      integralImg:
        "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_B/integral.png",
      levelIndex: 0,
      prizeSettingListLevel: [],
      echoDate: {},
      echoDate1: {},
      uploadSize3: false,
      activePage: false, //活动规则是否展示活动页
      peopleList: [],
      isStartEditTime: "",
      isStartEdit: false,
      valueRow: null,
      isCopy: false,
      activityData: {
        id: null,
      },
      backgroundOpacity: false,
      isSave: true,
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.state.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      levelList: [], // 会员等级列表
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      showDialog: false, // 选择奖品弹窗
      showDialog1: false, // 选择奖品弹窗
      selectGoodsState: false, // 曝光商品弹窗
      selectGoodsArr: [], // 曝光商品列表
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时

      ruleForm: {
        activityRulesText: "", //生成规则
        limitPerPerson: "", // 每人领奖限制
        theme: "会员升级礼", //活动主题
        description: "会员升级领好礼", //活动说明
        wordColor: "#1A1A1A", //文字颜色
        condFollow: false, // 是否需要关注店铺
        activityName: "", // 活动名称
        startTime: "", //活动开始时间
        endTime: "", //活动结束时间
        allowLevel: ["-1"], // 会员等级
        activityObject: 0,
        newOldCustomer: 0,
        partner: ["-1"],
        prizeSetType: 1, // 奖品设置 1统一设置，2按等级设置
        exposureSwitch: false, // 是否添加曝光商品
        itemList: [], // 曝光商品集合
        ruleDescription: "", //生成规则
        birthBeforeDay: null, //生日前XX天
        birthAfterDay: null, //生日后XX天
        settingType: 2, //统一奖品设置
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
      },
      //   prizeSettingList: [
      //     {
      //       // 统一奖品参数
      //       price: null,
      //       title: "",
      //       assetsId: null,
      //       prizeType: null,
      //       logo: "",
      //       discount: "",
      //       prizeCount: null, // 奖品总份数
      //       singleAmount: "",
      //       prizeCount: "",
      //     },
      //   ],
      tableData: [
        // 梯度奖品参数
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
          memberLevel: "0",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "change" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        activityTimeValue: [
          { required: true, message: " ", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "change" },
        ],
        allowLevel: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
      },
      generalCoupon: {
        // 通用优惠券
        couponType: 0,
      },
    };
  },
  created() {
    this.activityData = this.$route.query.activityData;
    const toBoolean = (val) => val === "true";

    console.log(this.activityData, "66666666", this.$route.query.valueRow);

    // 将 initEdit 和 getLevel 合并为一个异步函数
    const initData = async () => {
      await this.getLevel(); // 先执行 getLevel
      if (this.$route.query.valueRow) {
        // 查看活动
        this.backgroundOpacity = toBoolean(this.$route.query.backgroundOpacity);
        this.isSave = toBoolean(this.$route.query.isSave);
        this.isStartEdit = toBoolean(this.$route.query.isStartEdit);
        this.valueRow = this.$route.query.valueRow;
        setTimeout(() => this.getEdit(), 1000);
      } else if (this.$route.query.copyParams) {
        // 复制
        this.isCopy = true;
        this.backgroundOpacity = false;
        this.isSave = true;
        this.isStartEdit = false;
        this.valueRow = this.$route.query.copyParams.valueRow;
        setTimeout(() => this.getEdit(), 1000);
      } else {
        // 创建活动
        this.activityTimeChange();
      }
    };

    initData();
  },
  mounted() {
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
  },
  filters: {
    prizeType(num) {
      let result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "专属实物";
      }
      return result;
    },
  },
  methods: {
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    //修改数据回显
    getEdit() {
      var flag = "";
      flag = purchaseActivityDetail(this.valueRow.id);
      flag.then((res) => {
        let datas, change1, change2, days, daysStart, daysEnd, date3;
        daysStart = res.data.startTime.substring(0, 10);
        daysEnd = res.data.endTime.substring(0, 10);
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(res.data.endTime).getTime() -
          new Date(res.data.startTime).getTime();
        let leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
        this.activityTimeValue = [
          String(res.data.startTime),
          String(res.data.endTime),
        ];
        this.isStartEditTime = res.data.startTime;
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        if (this.isCopy) {
          this.ruleForm.activityRulesText = ""; //生成规则
        } else {
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.ruleForm.bonusPoints = Number(
            res.data.pointActivityPrizeDTO.price
          );
          this.ruleForm.minNum = Number(res.data.pointActivityPrizeDTO.price);
        }
        this.ruleForm.activityObject = res.data.hasOwnProperty("activityObject")
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty("newOldCustomer")
          ? res.data.newOldCustomer
          : 0;
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.isExposureItem = res.data.isExposureItem;
        this.ruleForm.condFollow = res.data.condFollow == 1 ? true : false;
        let draft = res.data.ruleDto;
        // 会员升级礼新增-回显
        let memberLevels = draft.memberLevels.map((item) => String(item));
        this.ruleForm.partner = memberLevels;
        if(draft.limitPerPerson){
          this.ruleForm.limitPerPerson = String(draft.limitPerPerson)
        }else{
          this.ruleForm.limitPerPerson = ''
        }
        //活动页设置
        let activeSetting = JSON.parse(draft.customerPaperwork);
        this.ruleForm.theme = activeSetting.theme;
        this.ruleForm.description = activeSetting.description;
        this.ruleForm.wordColor = activeSetting.wordColor;
        if (res.data.allowLevel) {
          let allowLevelArr = res.data.allowLevel.split(",");
          allowLevelArr.forEach((item, index) => {
            if (item == -1) {
              item = "-1";
            } else {
              item = Number(item);
            }
          });
          this.ruleForm.allowLevel = allowLevelArr;
        }
        // 深拷贝数组，不然吃很多数据问题的亏呀。。。
        this.initPrizeSet = this.deepClone(res.data.memberUpdatePrizeMap);
        //曝光商品
        this.ruleForm.exposureSwitch =
          res.data.isExposureItem == 0 ? false : true;
        console.log(this.ruleForm.exposureSwitch);
        // 商品处理
        let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.selectGoodsArr = shopList;
        this.itemListFor = shopList;
        this.mainImagelist = shopList;
        this.prizeSettingListLevel = this.getChooseLevel.map((item) => {
          var obj = {
            customerLevel: item.value,
            label: item.label,
            sortIndex: 0,
            settingList: [],
            memberLevelCondition: "", // 等级条件
            jumpType: 0, // 点击去升级类型
            jumpInfo: "", // 选择活动等
            // 等级权益列表
            gradeEquityList: [],
            // 活动页设置
            backgroundImage: "", //背景图
            buttonWordColor: "", //按钮文字颜色
            buttonBackgroundImg: "", //按钮背景图
          };
          // 等级奖品回显
          for (const key in res.data.memberUpdatePrizeMap) {
            if (item.value == key) {
              obj.settingList = res.data.memberUpdatePrizeMap[key];
            }
          }

          // 等级对应权益回显
          for (const key in res.data.activityMemberBenifitMap) {
            if (item.value == key) {
              obj.gradeEquityList = res.data.activityMemberBenifitMap[key].map(
                (item) => {
                  return {
                    ...item,
                    id: item.memberBenefitId,
                    benefitEnableIconUrl: item.iconUrl,
                  };
                }
              );
            }
          }
          // 等级规则回显
          draft.memberLevelRules.forEach((rule) => {
            if (item.value == rule.level) {
              obj.memberLevelCondition = rule.memberLevelCondition;
              obj.jumpType = rule.jumpType;
              obj.jumpInfo =
                rule.jumpType == 1 ? JSON.parse(rule.jumpInfo) : rule.jumpInfo;
            }
          });

          return obj;
        });
      });
    },
    selectEquity(val) {
      this.prizeSettingListLevel[this.levelIndex].gradeEquityList = val;
    },
    checkListchange1(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.allowLevel = ["-1"];
        }
      });
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          this.levelList = res.data.map((item) => {
            return {
              label: item.customerLevelName,
              value: item.customerLevel + "",
            };
          });
          // 去除非会员等级
          this.levelList = this.levelList.filter((item) => item.value != 0);
          this.prizeSettingListLevel = this.levelList.map((item) => {
            return {
              customerLevel: String(item.value),
              label: item.label,
              sortIndex: 0,
              // 其他条件
              memberLevelCondition: "", // 等级条件
              jumpType: 0, // 点击去升级类型
              jumpInfo: "", // 选择活动等
              // 等级权益列表
              gradeEquityList: [],
              settingList: [
                {
                  awardLevel: item.value,
                  sort: 0,
                  prizeType: null,
                  price: null,
                  totalAmount: null,
                  percentage: null,
                  title: null,
                  remanentAmount: null,
                  totalAmount: null, // 奖品总份数
                  // 领取设置
                  highLevelGetFlag: true,
                  upgradeGetFlag: true,
                  downgradeGetFlag: true,
                },
              ],
            };
          });
        })
        .catch((res) => {});
    },
    // 删除
    itemDel(index, item) {
      item.sortIndex -= 1;
      item.settingList.splice(index, 1);
    },
    upLvGoods(index, row) {
      row.settingList[index].sort -= 1;
      let target = row.settingList.splice(
        index - 1,
        1,
        row.settingList[index]
      )[0];
      target.sort += 1;
      this.$set(row.settingList, index, target);
    },
    downLvGoods(index, row) {
      row.settingList[index].sort += 1;
      let target = row.settingList.splice(
        index + 1,
        1,
        row.settingList[index]
      )[0];
      target.sort -= 1;
      this.$set(row.settingList, index, target);
    },
    //添加奖品
    addSetting(item) {
      if (this.backgroundOpacity) return;
      if (item.settingList.length > 4)
        return this.$message.warning("最多只能设置5个奖品");
      item.sortIndex = item.sortIndex + 1;
      item.settingList.push({
        awardLevel: item.customerLevel,
        sort: item.sortIndex,
        prizeType: null,
        price: null,
        totalAmount: null,
        percentage: null,
        title: null,
        remanentAmount: null,
        totalAmount: null, // 奖品总份数
        // 领取设置
        highLevelGetFlag: true,
        upgradeGetFlag: true,
        downgradeGetFlag: true,
      });
    },
    textColorReset() {
      this.ruleForm.wordColor = "#1A1A1A";
    },
    //添加权益
    addEquity(item) {
      // if (this.backgroundOpacity) return;
      if (item.gradeEquityList.length >= 20) {
        this.$message.warning("最多只能设置20个权益");
        return;
      }
      this.isSelectEquity = true;
    },
    equityDel(index, item) {
      item.sortIndex -= 1;
      item.gradeEquityList.splice(index, 1);
    },
    upEquity(index, item) {
      item.gradeEquityList[index].sort -= 1;
      let target = item.gradeEquityList.splice(
        index - 1,
        1,
        item.gradeEquityList[index]
      )[0];
      target.sort += 1;
      this.$set(item.gradeEquityList, index, target);
    },
    downEquity(index, item) {
      item.gradeEquityList[index].sort += 1;
      let target = item.gradeEquityList.splice(
        index + 1,
        1,
        item.gradeEquityList[index]
      )[0];
      target.sort -= 1;
      this.$set(item.gradeEquityList, index, target);
    },

    // 删除
    deleteSetting(index, item) {
      // 会员
      if (item) {
        item.settingList.splice(index, 1);
      } else {
        this.prizeSettingList.splice(index, 1);
      }
    },
    // 添加奖项
    addSettingAll() {
      if (this.prizeSettingList.length > 3)
        return this.$message.warning("最多只能设置4个奖品");
      this.prizeSettingList.push({
        // 统一奖品参数
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        prizeCount: null, // 奖品总份数
        singleAmount: "",
      });
    },
    //按等级设置添加奖项
    // addSetting(item) {
    //   console.log(item, "656546546");

    //   if (item.settingList.length > 3)
    //     return this.$message.warning("最多只能设置4个奖品");
    //   item.settingList.push({
    //     // 统一奖品参数
    //     memberLevel: item.customerLevel,
    //     price: null,
    //     title: "",
    //     assetsId: null,
    //     prizeType: null,
    //     logo: "",
    //     discount: "",
    //     prizeCount: null, // 奖品总份数
    //     singleAmount: "",
    //   });
    //   console.log(item.settingList, "545554");
    // },
    levelClick(index) {
      this.levelIndex = index;
    },
    //上传图片前校验   按阶级名次奖品图片设置
    beforeUpload3(file) {
      let _this = this;
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.onload = function () {
        console.log("宽高", image.width, image.height);
        const valid = image.width == 208 && image.height == 208;
        file.isFlag = valid;
        _this.uploadSize3 = valid;
        console.log(valid);
        if (valid) {
        } else {
          _this.$message.warning("图片宽高不符合要求,请重新上传");
          sizetype = false;
          return false;
        }
      };
      image.src = _URL.createObjectURL(file);
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      let sizetype = false;
      if (!isLt3M) {
        this.$message.warning("上传图片大小不能超过 1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  按阶级名次奖品图片设置
    handleUpload3(res, scope) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        if (this.uploadSize3) {
          this.$set(scope.row, "logo", res.data);
        }
      }
    },
    // 上传成功  按阶级名次奖品图片设置
    handleUpload2(res, scope) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        if (this.uploadSize) {
          this.$set(scope.row, "logo", res.data);
        }
      }
    },
    // 重置背景图  按阶级名次奖品图片设置
    picUrlReset3(scope) {
      this.$set(scope.row, "logo", this.priceImg);
    },
    //按阶梯删除
    deleteClass(index) {
      this.tableData.splice(index, 1);
    },
    // 按阶级新增
    addClass() {
      if (this.tableData.length === 4) {
        this.$message.warning("最多可设置4个阶梯区间");
        return;
      }
      this.tableData.push({
        // 统一奖品参数
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        prizeCount: null, // 奖品总份数
        singleAmount: "",
      });
    },
    //活动规则页面
    handleCheckAllChangeTaoBao(val) {
      this.activePage = val;
    },
    //回显
    typeDetail() {
      getActivity(this.valueRow.id)
        .then((res) => {
          let datas, change1, change2, days, daysStart, daysEnd, date3;
          daysStart = res.data.startTime.substring(0, 10);
          daysEnd = res.data.endTime.substring(0, 10);
          datas = daysEnd.split("-");
          change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          datas = daysStart.split("-");
          change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
          this.timeDay = days;
          //计算小时
          date3 =
            new Date(res.data.endTime).getTime() -
            new Date(res.data.startTime).getTime();
          let leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
          this.activityTimeValue = [
            String(res.data.startTime),
            String(res.data.endTime),
          ];

          if (this.isStartEdit) {
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime);
          }

          console.log("活动规则");
          // 活动规则赋值
          let { ruleDto, pointActivityPrizeDTOList } = res.data;
          let { birthBeforeDay, birthAfterDay, prizeSetType } = ruleDto;
          this.ruleForm.birthBeforeDay = birthBeforeDay;
          this.ruleForm.birthAfterDay = birthAfterDay;
          this.ruleForm.prizeSetType = this.isCopy ? 1 : prizeSetType;

          this.ruleForm.activityName = res.data.activityName;
          this.ruleForm.startTime = String(res.data.startTime);
          this.ruleForm.endTime = String(res.data.endTime);
          this.ruleForm.activityObject = res.data.hasOwnProperty(
            "activityObject"
          )
            ? res.data.activityObject
            : 0;
          this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
            "newOldCustomer"
          )
            ? res.data.newOldCustomer
            : 0;
          this.peopleList =
            res.data.hasOwnProperty("seniorGroupId") &&
            res.data.seniorGroupId.length > 0
              ? res.data.seniorGroupId.split(",")
              : [];

          if (res.data.allowLevel) {
            let allowLevelArr = res.data.allowLevel.split(",");
            allowLevelArr.forEach((item, index) => {
              if (item == "-1") {
                item = "-1";
              } else {
                item = Number(item);
              }
            });
            this.ruleForm.allowLevel = allowLevelArr;
          }
          this.ruleForm.ruleDescription = this.isCopy
            ? ""
            : String(res.data.ruleDescription); //生成规则
          // this.ruleForm.allowLevel = res.data.allowLevel.split(",");

          //是否展示活动规则
          this.activePage = res.data.isDisplayRule == 1 ? true : false;
          if (prizeSetType == 1) {
            //统一设置
            if (!this.isCopy) {
              //等级回显
              this.ruleForm.settingType =
                res.data.ruleDto.prizeSetType == 1 ? 2 : 1;
              this.prizeSettingList = res.data.pointActivityPrizeDTOList.map(
                (item) => {
                  item.prizeCount = item.totalAmount;
                  return {
                    ...item,
                  };
                }
              );
            }
            this.checkListchange(this.ruleForm.partner);
          } else {
            if (!this.isCopy) {
              if (
                res.data.pointActivityPrizeDTOList &&
                res.data.pointActivityPrizeDTOList.length
              ) {
                // 全部
                let levelArr = [];
                if (this.ruleForm.partner.includes("-1")) {
                  levelArr = this.levelList;
                } else {
                  levelArr = this.levelList.filter((item) =>
                    this.ruleForm.partner.includes(item.value)
                  );
                }
                this.ruleForm.settingType =
                  res.data.ruleDto.prizeSetType == 1 ? 2 : 1;
                this.prizeSettingListLevel = levelArr.map((item) => {
                  const obj = {
                    customerLevel: item.value,
                    name: item.name,
                    settingList: [],
                  };
                  res.data.pointActivityPrizeDTOList.forEach((list) => {
                    if (item.value == list.memberLevel) {
                      obj.settingList.push({
                        ...list,
                        prizeCount: list.totalAmount,
                      });
                    }
                  });
                  return obj;
                });
              }
            } else {
              this.checkListchange(this.ruleForm.partner);
            }
          }
          //曝光商品
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          console.log(this.ruleForm.exposureSwitch);
          // 商品处理
          let shopList = res.data.itemList
            ? res.data.itemList.map((item) => {
                return {
                  ...item,
                  numIid: item.wareId,
                  itemTitle: item.title,
                  picUrl: item.logo,
                };
              })
            : [];
          this.selectGoodsArr = shopList;
          this.itemListFor = shopList;
          this.mainImagelist = shopList;

          this.activityTimeChange();
        })
        .catch(() => {});
    },

    // 活动进行中修改奖品数量
    beAdd(row, type = 1) {
      console.log("活动进行中修改奖品数量");
      if (this.isStartEdit) {
        if (row) {
          if (type == 1) {
            if (row.minNum && Number(row.totalAmount) < Number(row.minNum)) {
              row.totalAmount = row.minNum;
              this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
            }
          } else if (type == 2) {
            if (row.minNum && Number(row.prizeCount) < Number(row.minNum)) {
              row.prizeCount = row.minNum;
              this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
            }
          }
        } else {
          console.log(
            "this.prizeSettingList.totalAmount",
            this.prizeSettingList.totalAmount
          );
          console.log(
            "this.prizeSettingList.minNum",
            this.prizeSettingList.minNum,
            Number(this.prizeSettingList.totalAmount) <
              Number(this.prizeSettingList.minNum) &&
              this.prizeSettingList.minNum
          );
          if (
            Number(this.prizeSettingList.totalAmount) <
              Number(this.prizeSettingList.minNum) &&
            this.prizeSettingList.minNum
          ) {
            this.prizeSettingList.totalAmount = this.prizeSettingList.minNum;
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
          }
        }
      }
    },

    // 打开选择奖品弹窗
    centerVis(scope) {
      console.log("123123123213");
      this.tableIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.prizeCount;
      this.echoDate = scope.row;
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    centerVis2(scope) {
      this.tableIndex1 = scope.$index;
      this.JingdouCount1.prizeCount = scope.row.prizeCount;
      this.echoDate1 = scope.row;
      this.showDialog1 = true;
      this.$nextTick(() => {
        this.$refs.selectProduct1.openDialog();
      });
    },

    // 关闭选择奖品
    colseDialog() {
      this.showDialog = false;
    },
    colseDialog1() {
      this.showDialog1 = false;
    },

    //选择奖品数据
    getTheData(data, prizeType) {
      this.showDialog = false;
      const prizeSetting = this.prizeSettingList[this.tableIndex];

      // 按阶梯
      prizeSetting.prizeType = prizeType;
      prizeSetting.price = data.discount || data.singleAmount;
      prizeSetting.singleAmount = data.singleAmount;
      prizeSetting.title = data.name || prizeType;
      prizeSetting.assetsId = Number(data.couponId);
      prizeSetting.logo = data.logo || this.priceImg;
      switch (prizeType) {
        case 1: // 优惠券
          prizeSetting.quota = data.quota;
          prizeSetting.couponType = data.couponType;
          prizeSetting.logo = this.couponImg;
          prizeSetting.assetsId = data.batchKey;
          break;
        case 3: // 实物
          prizeSetting.skuId = data.skuId;
          break;
        case 4: // 积分
          prizeSetting.logo = this.integralImg;
          break;
        case 10: // 实物-专属下单
          prizeSetting.price = data.price;
          prizeSetting.assetsId = data.id;
          prizeSetting.title = data.itemTitle;
          prizeSetting.logo = data.picUrl;
          break;
      }
    },
    getTheData1(data, prizeType) {
      console.log(data, "54545445455454");

      this.showDialog1 = false;
      // 按阶梯
      const setting =
        this.prizeSettingListLevel[this.levelIndex].settingList[
          this.tableIndex1
        ];
      setting.prizeType = prizeType;
      setting.price = data.discount || data.singleAmount;
      setting.singleAmount = data.singleAmount;
      setting.title = data.name || prizeType;
      setting.assetsId = Number(data.couponId);
      setting.logo = data.logo || this.priceImg;
      // 优惠券
      if (prizeType === 1) {
        setting.quota = data.quota;
        setting.couponType = data.couponType;
        setting.logo = this.couponImg;
        setting.assetsId = data.batchKey;
        setting.price = data.price;
      }
      // 实物
      if (prizeType === 3) {
        setting.skuId = data.skuId;
      }
      // 积分
      if (prizeType === 4) {
        setting.logo = this.integralImg;
      }
      // 实物-专属下单
      if (prizeType === 10) {
        setting.price = data.price;
        setting.assetsId = data.id;
        setting.title = data.itemTitle;
        setting.logo = data.picUrl;
      }
      // 开启订单备注
      if (data.prizeRemarkType == 1) {
        setting.prizeRemarkType = data.prizeRemarkType;
        setting.pointActivityPrizeRemark = {
          receivePayment: data.receivePayment,
          tradeLimitTime: data.tradeLimitTime,
          tradeLimitTimeUnit: data.tradeLimitTimeUnit,
          itemType: data.itemType,
          tradeFlag: data.tradeFlag,
          content: data.content,
          remarkActionType: data.remarkActionType,
          numIid: data.itemType
            ? data.goodsList.map((item) => item.wareId).join(",")
            : "",
        };
        if (data.remarkActionType == "1") {
          setting.pointActivityPrizeRemark.startCreateTradeTimeForManualLinkTrade =
            data.startCreateTradeTimeForManualLinkTrade;
          setting.pointActivityPrizeRemark.endCreateTradeTimeForManualLinkTrade =
            data.endCreateTradeTimeForManualLinkTrade;
        } else {
          setting.pointActivityPrizeRemark.tradeLimitTime = data.tradeLimitTime;
          setting.pointActivityPrizeRemark.tradeLimitTimeUnit =
            data.tradeLimitTimeUnit;
        }
      }
    },
    setPrizeTxt(item) {
      if (item.prizeType == 8) {
        item.prizeTxt = item.price + "元";
      } else {
        if (item.couponType == 4) {
          item.prizeTxt = item.price;
        } else {
          item.prizeTxt = item.singleAmount;
        }
      }
    },

    //清空统一奖品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },

    // 弹框确认
    // handleDialogCloseAnoth() {
    //   this.ruleForm.startTime = this.activityTimeValue[0];
    //   this.ruleForm.endTime = this.activityTimeValue[1];
    //   //对象排序(根据对象的某一属性)
    //   // if (this.draggingId.length != []) {
    //   //   let a = this.draggingId;
    //   //   let b = [];
    //   //   for (let i = 0; i < a.length; i++) {
    //   //     this.itemListFor.find((obj) => {
    //   //       if (obj.skuId == a[i]) {
    //   //         b.push({
    //   //           logo: obj.logo,
    //   //           price: obj.price,
    //   //           title: obj.title,
    //   //           skuId: obj.skuId,
    //   //           wareId: obj.numIid,
    //   //         });
    //   //       }
    //   //     });
    //   //   }
    //   // }
    //   //活动名称的限制
    //   if (
    //     !this.ruleForm.activityName ||
    //     this.ruleForm.activityName.length == 0
    //   ) {
    //     this.$message.warning("请输入活动名称");
    //     return;
    //   }
    //   //活动时间的限制
    //   if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
    //     this.$message.warning("请输入活动时间");
    //     return;
    //   }

    //   if (!this.ruleForm.ruleDescription) {
    //     this.$message.warning("活动规则不能为空");
    //     return;
    //   }

    //   //判断勾选提示后即可调取接口
    //   if (this.checked == true) {
    //     let {
    //       birthBeforeDay,
    //       birthAfterDay,
    //       prizeSetType,
    //       exposureSwitch,
    //       allowLevel,
    //       ...formParams
    //     } = this.ruleForm;
    //     let obj = {
    //       ...formParams,
    //       // allowLevel: allowLevel.join(","),
    //       activityObject: this.ruleForm.activityObject,
    //       isDisplayRule: this.activePage == false ? "0" : "1",
    //       newOldCustomer: this.ruleForm.newOldCustomer,
    //       seniorGroupId: this.peopleList.join(","),
    //       allowLevel: this.ruleForm.allowLevel.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
    //       isExposureItem: exposureSwitch ? 1 : 0,
    //       activityType: this.activityData.id, //活动类型
    //       ruleDTO: {
    //         birthBeforeDay,
    //         birthAfterDay,
    //         prizeSetType,
    //       },
    //       pointActivityPrizeDTOList: [],
    //       itemList: this.itemListFor.map((item) => {
    //         return {
    //           logo: item.logo,
    //           price: item.price,
    //           title: item.title,
    //           skuId: item.skuId,
    //           wareId: item.numIid,
    //         };
    //       }),
    //     };
    //     obj.ruleDTO.prizeSetType = this.ruleForm.settingType == 2 ? 1 : 2;
    //     //奖品设置传参
    //     if (this.ruleForm.settingType == 1) {
    //       // 如果 settingType 为 1，需要在这里添加相应的逻辑
    //       this.prizeSettingListLevel.forEach((list) => {
    //         list.settingList.forEach((item) => {
    //           let prize = {
    //             title: item.title,
    //             assetsId: item.assetsId,
    //             prizeType: item.prizeType,
    //             logo: item.logo,
    //             discount: item.price || item.singleAmount,
    //             singleAmount: item.singleAmount,
    //             price: item.price,
    //             totalAmount: item.prizeCount, // 总数额
    //             memberLevel: Number(item.memberLevel),
    //           };
    //           if (prize.prizeType == 3) {
    //             prize.logo = item.logo;
    //             prize.assetsId = item.skuId || item.assetsId;
    //           }
    //           if (prize.prizeType == 1) {
    //             prize.quota = item.quota;
    //             prize.couponType = item.couponType;
    //           }
    //           if (prize.prizeType == 2 || prize.prizeType == 4) {
    //             prize.singleAmount = item.price;
    //           } else {
    //             prize.singleAmount = 1;
    //           }
    //           obj.pointActivityPrizeDTOList.push(prize);
    //         });
    //       });
    //     } else {
    //       //统一设置
    //       obj.pointActivityPrizeDTOList = this.prizeSettingList.map((item) => {
    //         let prize = {
    //           title: item.title,
    //           assetsId: item.assetsId,
    //           prizeType: item.prizeType,
    //           logo: item.logo,
    //           discount: item.price || item.singleAmount,
    //           singleAmount: item.singleAmount,
    //           price: item.price,
    //           totalAmount: item.prizeCount, // 总数额
    //         };
    //         if (prize.prizeType == 3) {
    //           prize.logo = item.logo;
    //           prize.assetsId = item.skuId || item.assetsId;
    //         }
    //         if (prize.prizeType == 1) {
    //           prize.quota = item.quota;
    //           prize.couponType = item.couponType;
    //         }
    //         if (prize.prizeType == 2 || prize.prizeType == 4) {
    //           prize.singleAmount = item.price;
    //         } else {
    //           prize.singleAmount = 1;
    //         }
    //         return prize; // 返回单个奖品对象
    //       });
    //     }
    //     //创建传模板id
    //     if (this.$route.query.valueRow && !this.isCopy) {
    //       obj.id = this.valueRow.id;
    //     } else {
    //       obj.templateId = this.activityData.templateId;
    //     }
    //     //end
    //     saveOrUpdate(obj).then((res) => {
    //       console.log("保存活动", res);
    //       this.joinBlackList = false;
    //       if (res.code == 1) {
    //         this.$message.success(res.message);
    //         this.$router.push({ path: "activeList1" });
    //       } else {
    //         this.$message.error(res.message);
    //       }
    //     });
    //     return;
    //   } else {
    //     this.$message.info("请勾选明确活动规则后即可创建");
    //     return;
    //   }
    // },
    async handleDialogCloseAnoth() {
      //活动时间
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      //设置规则
      let memberUpdatePrizeMap = {};
      this.prizeSettingListLevel.forEach((item) => {
        memberUpdatePrizeMap = {
          ...memberUpdatePrizeMap,
          [item.customerLevel]: item.settingList,
        };
      });
      // 等级规则设置
      let memberLevelRules = this.prizeSettingListLevel.map((item) => {
        return {
          level: item.customerLevel,
          memberLevelCondition: item.memberLevelCondition,
          jumpInfo: item.jumpInfo, //点击去升级
        };
      });
      // 等级对应权益
      let activityMemberBenifitMap = {};
      this.prizeSettingListLevel.forEach((item) => {
        // 没有选择权益就不传
        if (item.gradeEquityList.length > 0) {
          activityMemberBenifitMap = {
            ...activityMemberBenifitMap,
            [item.customerLevel]: item.gradeEquityList.map((item) => {
              return {
                memberBenefitId: item.id,
              };
            }),
          };
        }
      });
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        activityObject: this.ruleForm.activityObject,
        newOldCustomer: this.ruleForm.newOldCustomer,
        condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
        activityType: this.activityData.id,
        allowLevel: this.ruleForm.allowLevel.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        activityMemberBenifitMap: activityMemberBenifitMap, //权益
        // 关注店铺
        ruleDTO: {
          customerPaperwork: JSON.stringify({
            theme: this.ruleForm.theme, //活动主题
            description: this.ruleForm.description, //活动说明题
            wordColor: this.ruleForm.wordColor, //文字颜色
          }),
          limitPerPerson: this.ruleForm.limitPerPerson?this.ruleForm.limitPerPerson:'',
          memberLevels: this.ruleForm.partner,
          subType: this.activityData.activityType, //活动类型  16: 下单有礼 17: 首购有礼 18:复购有礼
          prizeRule: this.ruleForm.prizeRule,
          prizeShowType: this.ladder.prizeShowType,
          orderCountType: this.ladder.orderCountType,
          memberLevelRules: memberLevelRules, //等级规则设置
          filterType: this.ruleForm.filterType,
          skuIdList:
            this.ruleForm.filterType == 2
              ? this.itemListForFilter1.map((item) => {
                  return {
                    logo: item.logo,
                    jdPrice: item.price,
                    skuName: item.title,
                    skuId: item.skuId,
                    wareId: item.numIid,
                  };
                })
              : this.itemListForFilter.map((item) => {
                  return {
                    logo: item.logo,
                    jdPrice: item.price,
                    skuName: item.title,
                    skuId: item.skuId,
                    wareId: item.numIid,
                  };
                }),
        }, //活动名称
        pointActivityPrizeDTOList: [], // 奖品
        itemList: this.itemListFor.map((item) => {
          return {
            logo: item.logo,
            price: item.price,
            title: item.title,
            skuId: item.skuId,
            wareId: item.numIid,
          };
        }), //曝光商品集合
        points: 10,
        memberUpdatePrizeMap: memberUpdatePrizeMap,
      };
      //奖品设置
      this.prizeSettingListLevel.forEach((list) => {
        list.settingList.forEach((item) => {
          let prize = {
            title: item.title,
            assetsId: item.assetsId,
            prizeType: item.prizeType,
            logo: item.logo,
            discount: item.price || item.singleAmount,
            singleAmount: item.singleAmount,
            price: item.price,
            totalAmount: item.totalAmount, // 总数额
            memberLevel: Number(item.awardLevel),
          };
          if (prize.prizeType == 3) {
            prize.logo = item.logo;
            prize.assetsId = item.skuId || item.assetsId;
          }
          if (prize.prizeType == 1) {
            prize.quota = item.quota;
            prize.couponType = item.couponType;
          }
          if (prize.prizeType == 2 || prize.prizeType == 4) {
            prize.singleAmount = item.price;
          } else {
            prize.singleAmount = 1;
          }
          cardParams.pointActivityPrizeDTOList.push(prize);
        });
      });
      console.log(cardParams, "564564566456");
      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if (this.itemListFor.length === 0) {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }
      //活动规则不能为空
      if (!this.ruleForm.activityRulesText) {
        this.$message.warning("活动规则不能为空");
        return;
      }
      //   if (this.nowType == "draft") {
      //     delete cardParams.id;
      //   }
      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        //创建传模板id
        if (this.$route.query.valueRow && !this.isCopy) {
          cardParams.id = this.valueRow.id;
        } else {
          cardParams.templateId = this.activityData.templateId;
        }
        // if (
        //   this.activityData.id && !this.isCopy
        // ) {
        //   createMemberUpgradeGift({
        //     ...cardParams,
        //     id: this.valueRow.id,
        //   }).then((res) => {
        //     if (res.code == 1) {
        //       this.$message.success(res.message);
        //       //   this.$router.push({
        //       //     path: "/interaction",
        //       //     hash: "#/activityManager",
        //       //   });
        //       this.$router.push({ path: "activeList1" });
        //     } else {
        //       this.$message.error(res.message);
        //     }
        //   });
        // } else {
        //   //   cardParams.templateId = this.activityData.templateId;
        //   createMemberUpgradeGift(cardParams).then((res) => {
        //     if (res.code == 1) {
        //       this.$message.success(res.message);
        //       //   this.$router.push({
        //       //     path: "/interaction",
        //       //     hash: "#/activityManager",
        //       //   });
        //       this.$router.push({ path: "activeList1" });
        //     } else {
        //       this.$message.error(res.message);
        //     }
        //   });
        // }
        createMemberUpgradeGift(cardParams).then((res) => {
          if (res.code == 1) {
            this.$message.success(res.message);
            this.$router.push({ path: "activeList1" });
          } else {
            this.$message.error(res.message);
          }
        });
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //清除
    cleanData(row) {
      if (this.activityData.isStart || this.backgroundOpacity) return;
      row.assetsId = null;
      row.prizeType = null;
      row.price = null;
      row.title = null;
      row.logo = null;
      row.percentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
    },

    // 活动时间驱动
    activityTimeChange() {
      if (!this.activityTimeValue) {
        this.activityTimeValue = [];
        return;
      }
      if (this.isStartEdit) {
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0] = this.isStartEditTime;
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let CRMtime = new Date(this.orderCRMtime).valueOf();
      let invalidateDate = new Date(
        this.$store.state.loginUserInfo.expiredIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.activityStartTime &&
        this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.activityEndTime &&
        this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      //   if (this.nowType == "look") return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        // if (this.nowType != "edit" && this.nowType != "look") {
        //   this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
        //   this.activityTimeValue[0] = "";
        //   this.ruleForm.activityStartTime = null;
        //   return;
        // }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
    },

    // 保存编辑
    saveEdit() {
      let state = true;
      if (this.ruleForm.prizeSetType == 2) {
        let arr = this.tableData.map((i) => {
          return i.peopleCount;
        });
        let copyArr = JSON.parse(JSON.stringify(arr)).sort((a, b) => {
          return a - b;
        });
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] != copyArr[i]) {
            state = false;
          }
        }
        if (!state) {
          return this.$message.error("邀请人数梯度不可大于上一个梯度1");
        }
      }
      this.joinBlackList = true;
    },
    // 下一步
    resetForm() {
      this.joinBlackList = true;
    },
    // 打开曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    // 选择曝光商品
    selectGoodsClose(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      this.selectGoodsState = false;
    },
    // 删除曝光商品
    delec(item, index) {
      let i = "-1";
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      console.log(i, 55555);
      if (i != "-1") {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
      }
      console.log(this.mainImagelist, 4444444);
    },
    // 曝光商品图片拖拽结束
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      console.log("this.mainImagelist)", this.mainImagelist);
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        // this.draggingId = arr;
      });
    },

    //选中改变
    checkListchange(val) {
      // 重置选中状态
      this.levelIndex = 0;
      this.levelSkinIndex = 0;
      // 全部
      let levelArr = [];
      if (val[val.length - 1] == "-1" || this.ruleForm.partner.length == 0) {
        this.ruleForm.partner = ["-1"];
        levelArr = this.levelList;
      } else {
        this.ruleForm.partner = val.filter((item) => item != "-1");
        levelArr = this.levelList.filter((item) => val.includes(item.value));
      }
      this.prizeSettingListLevel = levelArr.map((level) => {
        const index = this.prizeSettingListLevel.findIndex(
          (item) => item.customerLevel == level.value
        );
        // 已存在
        if (index != -1) {
          return this.prizeSettingListLevel[index];
        } else {
          return {
            customerLevel: level.value,
            label: level.label,
            sortIndex: 0,
            // 其他条件
            memberLevelCondition: "", // 等级条件
            jumpType: 0, // 点击去升级类型
            jumpInfo: "", // 选择活动等
            // 等级权益列表
            gradeEquityList: [],
            settingList: [
              {
                awardLevel: level.value,
                sort: 0,
                prizeType: null,
                price: null,
                totalAmount: null,
                percentage: null,
                title: null,
                remanentAmount: null,
                totalAmount: null, // 奖品总份数
                // 领取设置
                highLevelGetFlag: true,
                upgradeGetFlag: true,
                downgradeGetFlag: true,
              },
            ],
          };
        }
      });
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "";

      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text2 =
          "活动时间：" +
          this.ruleForm.activityStartTime +
          "~" +
          this.ruleForm.activityEndTime;
      }
      //参与对象
      if (
        this.ruleForm.activityObject == "1" &&
        this.ruleForm.allowLevel.length > 0
      ) {
        let levelText = [];
        this.ruleForm.allowLevel.forEach((item) => {
          if (item == "-1") {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              console.log(it, "54545545");
              if (it.value == item) {
                item = it.label;
              }
            });
          }
          levelText.push(item);
        });

        text3 = "活动参与对象：" + levelText.splice(",");
      } else {
        text3 = "活动参与对象：全部";
      }
      //活动条件
      if (this.ruleForm.condFollow) {
        text4 = "活动条件：" + "已关注店铺，可参与活动";
      }
      if (this.ruleForm.limitPerPerson) {
        text5 = "每人领奖次数限制：" + this.ruleForm.limitPerPerson + "次";
      }
      let Arr1 = [text1, text2, text3, text4, text5];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    // 返回
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
    },
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleList = [];
      this.ruleForm.allowLevel = ["-1"];
      this.peopleList = [];
    },
    filterLevel(level) {
      let target = this.levelList.find((item) => item.level == level);
      return target ? target.name : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.text-btn {
  width: auto;
  padding: 0px !important;
  margin-right: 10px;
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #fe4d45;
  }
  color: #999;
}

.flex {
  display: flex;
  align-items: center;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #2670fb;
    border: 1px dashed #2670fb;
    width: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  // min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 24px;

  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      height: 142px;
      width: 302px;
      .theBox {
        height: 142px;
        width: 302px;
        // border: 1px solid #999;
        background: url("../../assets/thdImg/pages/yhq.svg") no-repeat;
        border-radius: 8px;
        position: absolute;
        color: #333333;
        margin-bottom: 10px;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 100%;
          height: 100%;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }
  }
}

//统一奖品设置
.setting-level {
  display: flex;
  align-items: center;
  margin-top: 10px;
  //   margin-bottom: 10px;
  &-item {
    width: 125px;
    text-align: center;
    background-color: #e9effc;
    &__active {
      color: #fff;
      background-color: #2670fb;
    }
  }
}
//添加奖项
.add_btn1 {
  cursor: pointer;
  color: #2670fb;
  border: 1px solid #2670fb;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.btnGroup1 {
  display: flex;
  align-items: center;
}
.btnGroup {
  display: flex;
  justify-content: space-around;
  align-items: center;
  &_button {
    color: #2670fb;
    cursor: pointer;
  }
}
.del_box {
  position: absolute;
  left: 165px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
.btn-wrap {
  display: flex;
  align-items: center;
}
.add_btn1 {
  cursor: pointer;
  color: #7b61ff;
  border: 1px solid #7b61ff;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.setting-tip-red {
  color: red;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
// /deep/ .el-table__body-wrapper {
//   overflow: visible !important;
// }
// /deep/.prize_box .el-table__body-wrapper {
//   overflow: visible !important;
// }
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.prize_box {
  padding: 0 21px;
  background: #fff;
}
//v3.39
.display_inliene {
  display: inline-block;
}
.setting-level {
  display: flex;
  align-items: center;
  &-item {
    cursor: pointer;
    padding: 5px 14px;
    font-size: 14px;
    color: #999999;
    text-align: center;
    background: #f8f9fc;
    margin-right: 4px;
    border-bottom: 4px solid #ffffff;
    border-radius: 4px 4px 0 0;
    &__active {
      color: #2768ff;
      border-bottom: 4px solid #f8f9fc;
    }
  }
}
.rule-set-box {
  background: #f8f9fc;
  padding: 20px 20px 20px 0;
  border-radius: 4px;
}
.marginT16 {
  margin-top: 16px;
}
.flex-style {
  width: 100%;
}
.color-style {
  color: #999999;
  font-size: 14px;
}
.mr-bt-12 {
  margin-bottom: 12px;
}
.mr-r-6 {
  margin-right: 6px;
}
.points_task_polite-page {
  .prosi {
    position: absolute;
    bottom: 45px;
    right: 16px;
  }
  // /deep/.prize_box .el-table__body-wrapper {
  //   overflow: visible !important;
  // }
  /deep/ .el-table__row:hover {
    .delQx {
      display: flex;
    }
  }
}
.styleBtns {
  width: 30px !important;
}
</style>
